export default __webpack_public_path__ + "static/media/22.036cb2a9.jpg";